const baseState = {
    uri: null,
	removingDateTimeNotBefore: null,
	removingDateTimeNotAfter: null,
	ownerId: null,
	removingInitiatorId: null,
	operator: null
}

const removedTokenSearchReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_REMOVED_TOKEN_SEARCH_URI": {
			return {
				...state,
				uri: payload
			}
		}

		case "SET_REMOVED_TOKEN_SEARCH_REMOVED_DATE_NOT_BEFORE": {
			return {
				...state,
				removingDateTimeNotBefore: payload
			}
		}

		case "SET_REMOVED_TRASH_SEARCH_REMOVED_DATE_NOT_AFTER": {
			return {
				...state,
				removingDateTimeNotAfter: payload
			}
		}

		case "SET_REMOVED_TOKEN_SEARCH_OWNER_ID": {
			return {
				...state,
				ownerId: payload
			}
		}

		case "SET_REMOVED_TOKEN_SEARCH_REMOVING_INITIATOR_ID": {
			return {
				...state,
				removingInitiatorId: payload
			}
		}

		case "SET_REMOVED_TOKEN_SEARCH_OPERATOR": {
			return {
				...state,
				operator: payload
			}
		}

		case "CLEAR_ALL_REMOVED_TOKEN_SEARCH_FIELDS": {
			return {
				...state,
				uri: null,
				removingDateTimeNotBefore: null,
				removingDateTimeNotAfter: null,
				ownerId: null,
				removingInitiatorId: null,
				operator: null
			}
		}

        default:
            return state;
    }
}

export default removedTokenSearchReducer